import {useRef, useEffect} from 'react';

/**
 *  useAutoFocus custom hook
 *  Allows input to be focused based on focusDep bool
 */

export const useAutoFocus = (focusDep) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current && focusDep) {
      inputRef.current.focus();
    }
  }, [focusDep]);

  return inputRef;
};
